import SelectedLanguage from "./SelectedLanguage";

export default SelectedLanguage;
